import React from "react";

function Logo(props) {
  return (
    <img
      alt="Logo"
      src={process.env.PUBLIC_URL + "/static/leterago-white-logo-new.png"}
      {...props}
    />
  );
}

export default Logo;
